
import React from 'react';
import firebase from 'firebase';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';


const firestore = firebase.firestore();
const settings = {/* your settings... */ timestampsInSnapshots: true};
firestore.settings(settings);



var allLightstatus = firestore.collection("stoneStatus");

let id = 0;
function createData(name, calories, fat, carbs, protein) {
  id += 1;
  return { id, name, calories, fat, carbs, protein };
}

function createDisplayData(stoneId, testDate, errorDesc) {
    id += 1;
    return { id, stoneId, testDate, errorDesc};
  }
  

export default class StoneListing extends React.Component {
    state = {
        stonesArray : [],
    }

    allLightstatus = firestore.collection("stoneStatus");
    stonesArray = [];
    getAllStones = allLightstatus.get()
        .then(snapshot => {
            snapshot.forEach(doc => {
                
                console.log(doc.id, '=>', doc.data());
                this.stonesArray.push(createDisplayData(doc.data().stoneId, doc.data().dateTest, doc.data().stoneDesc));
                console.log(this.stonesArray.length);
            });
           this.setState({stonesArray : this.stonesArray})

        })
        .catch(err => {
            console.log('Error getting documents', err);
        });

    render(){
        return (
            <div>
            <br></br>
            <p>STONES REPORTING A FAULT : {this.state.stonesArray.length} </p>
            <Paper>
                <Table>
                <TableHead>
                    <TableRow>
                    <TableCell>Stone Number</TableCell>
                    <TableCell numeric>Test date</TableCell>
                    <TableCell numeric>Error</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {this.state.stonesArray.map(row => {
                    return (
                        <TableRow key={row.id}>
                        <TableCell component="th" scope="row">
                            {row.stoneId}
                        </TableCell>
                        <TableCell >{row.testDate}</TableCell>
                        <TableCell numeric>{row.errorDesc}</TableCell>
                        </TableRow>
                    );
                    })}
                </TableBody>
                </Table>
            </Paper>
            
           
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/Component/StoneListing.js